import { MaterialityMap, MaterialityMapProps } from '@esg/client/graphs-ui';
import { useInjectData } from './use-inject-data';

export function MaterialityPage() {
  const options = useInjectData<MaterialityMapProps>('materiality');

  return options ? (
    <MaterialityMap height="100vh" width="100vw" {...options} />
  ) : (
    <p>Loading...</p>
  );
}
